import React, { useEffect, useRef } from 'react';
import './CurtainAnimation.css';

const CurtainAnimation = () => {
  const curtainRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (curtainRef.current) {
        curtainRef.current.classList.add('animate-curtain');
      }
    }, 20);
  }, []);

  return (
    <div className="curtain-container">
      <div ref={curtainRef} className="curtain"></div>
    </div>
  );
};

export default CurtainAnimation;